import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';
import { MicrosoftAuthService } from '@services/core/authentication.service';
import { UserService } from '@services/core/user.service';
@NgModule({
    declarations: [ ],
    imports:      [ CommonModule, FormsModule, ReactiveFormsModule, NgSelectComponent],
    providers:    [ UserService, MicrosoftAuthService ],
    exports:      [ CommonModule,  ReactiveFormsModule , FormsModule, NgSelectComponent ],
})
export class CoreModule { }